export const CurrentTime = () =>
  new Date(Date.now()).toLocaleString().replace(/\s|,\s/g, '_')



// WEBPACK FOOTER //
// ./src/utils/CurrentTime.js